import * as I18n from 'circe/I18n';
import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/FORECASTDAT`;

export const REDUCER_NAME = 'FORECASTDAT';
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments/query`;

export const ROUTES = {
  ROOT: '/orders',
};
export const DELIVERY_MODES = [
  { value: 'DAT', label: 'DAT' },
  { value: 'FORECAST', label: 'FORECAST' },
];
export const TAGS = {
  'division:cement': I18n.str('grayCement', 'Gray Cement'),
  'division:white cement': I18n.str('whiteCement', 'White Cement'),
  'division:gate': I18n.str('masheedGate', 'Masheed Gate'),
  'division:cement replacement': I18n.str('cementReplacement', 'Cement Replacement'),
};
export const SALES_CATEGORIES = [
  {
    value: null,
    label: I18n.str('allCategories', 'All Categories'),
    subLabel: null,
  },
  {
    value: 'BLC-Bulk',
    label: I18n.str('BLC-Bulk', 'BLC-Bulk'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'PRECASTO',
    label: I18n.str('Precasto', 'Precasto'),
    subLabel: I18n.str('grayCement', 'Gray Cement'),
    tag: 'division:cement',
  },
  {
    value: 'JORDAN',
    label: I18n.str('Jordan', 'Jordan'),
    subLabel: I18n.str('grayCement', 'Gray Cement'),
    tag: 'division:cement',
  },

  {
    value: 'Type-II Bulk',
    label: I18n.str('Type-II Bulk', 'Type-II Bulk'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'Type-III Bulk',
    label: I18n.str('Type-III Bulk', 'Type-III Bulk'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'Cement Ash',
    label: I18n.str('Cement Ash', 'Cement Ash'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'White Cem-I Bulk',
    label: I18n.str('White Cem-I Bulk', 'White Cem-I Bulk'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
    tag: 'division:white cement',
  },
  {
    value: 'White Cem-II Bulk',
    label: I18n.str('White Cem-II Bulk', 'White Cem-II Bulk'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
    tag: 'division:white cement',
  },
  {
    value: 'Clinker',
    label: I18n.str('Clinker', 'Clinker'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'FNG-Bulk',
    label: I18n.str('FNG-Bulk', 'FNG-Bulk'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'MOH-Bulk',
    label: I18n.str('MOH-Bulk', 'MOH-Bulk'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'MCT-Bags',
    label: I18n.str('MCT-Bags', 'MCT-Bags'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'OPC-Bulk',
    label: I18n.str('OPC-Bulk', 'OPC-Bulk'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'PPC-Bulk',
    label: I18n.str('PPC-Bulk', 'PPC-Bulk'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'SRC-Bulk',
    label: I18n.str('SRC-Bulk', 'SRC-Bulk'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'WC-Bulk',
    label: I18n.str('WC-Bulk', 'WC-Bulk'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
    tag: 'division:white cement',
  },
  {
    value: 'WC-Import - Bulk',
    label: I18n.str('WC-Import - Bulk', 'WC-Import - Bulk'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'White Cem-I Bags',
    label: I18n.str('White Cem-I Bags', 'White Cem-I Bags'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
    tag: 'division:white cement',
  },
  {
    value: 'White Cem-II Bags',
    label: I18n.str('White Cem-II Bags', 'White Cem-II Bags'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
    tag: 'division:white cement',
  },
  {
    value: 'FHD-Bags',
    label: I18n.str('FHD-Bags', 'FHD-Bags'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'FNG-Bags',
    label: I18n.str('FNG-Bags', 'FNG-Bags'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'MOH-Bags',
    label: I18n.str('MOH-Bags', 'MOH-Bags'),
    subLabel: null,
    tag: null,
  },
  {
    value: 'OPC-Bags',
    label: I18n.str('OPC-Bags', 'OPC-Bags'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'PPC-Bags',
    label: I18n.str('PPC-Bags', 'PPC-Bags'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'SRC-Bags',
    label: I18n.str('SRC-Bags', 'SRC-Bags'),
    subLabel: 'Cement',
    tag: 'division:cement',
  },
  {
    value: 'WC-Bags',
    label: I18n.str('WC-Bags', 'WC-Bags'),
    subLabel: I18n.str('whiteCement', 'White Cement'),
  },
  {
    value: 'WC-Import - Bags',
    label: I18n.str('WC-Import - Bags', 'WC-Import - Bags'),
    subLabel: null,
  },
  {
    value: 'Flyash-Bags',
    label: 'Flyash-Bags',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
  {
    value: 'Flyash-Bulk',
    label: 'Flyash-Bulk',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
  {
    value: 'Microsilica-Bags',
    label: 'Microsilica-Bags',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
  {
    value: 'Microsilica-Bulk',
    label: 'Microsilica-Bulk',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
  {
    value: 'GGBFS-Bags',
    label: 'GGBFS-Bags',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
  {
    value: 'GGBFS-Bulk',
    label: 'GGBFS-Bulk',
    subLabel: I18n.str('cementReplacement', 'Cement Replacement'),
    tag: 'division:cement replacement',
  },
];
export const STATUS = [
  { value: null, label: I18n.str('all', 'All') },
  { value: 'PROPOSED', label: I18n.str('PROPOSED', 'PROPOSED') },
  { value: 'ORDERED', label: I18n.str('ORDERED', 'ORDERED') },
  { value: 'DISPATCHED', label: I18n.str('DISPATCHED', 'DISPATCHED') },
  { value: 'LOADING', label: I18n.str('LOADING', 'LOADING') },
  { value: 'IN_ROUTE', label: I18n.str('IN_ROUTE', 'IN ROUTE') },
  { value: 'UNLOADING', label: I18n.str('UNLOADING', 'UNLOADING') },
  { value: 'UNASSIGNED', label: I18n.str('UNASSIGNED', 'UNASSIGNED') },
  { value: 'EXCEPTION', label: I18n.str('EXCEPTION', 'EXCEPTION') },
  { value: 'DELIVERED', label: I18n.str('DELIVERED', 'DELIVERED') },
  { value: 'CANCELLED', label: I18n.str('CANCELLED', 'CANCELLED') },
];

export const TYPE_OF_ASSIGN = {
  vendorCompaniesToGroup: 'vendorCompanies',
  vendorsToGroup: 'vendors',
};
